import * as React from "react";
import { createTheme, TextField, ThemeProvider } from "@mui/material";
import { useState } from "react";

interface FormBasicInfoInputProps {
  label?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  onClick?: () => void;
  id?: string;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  placeholder?: string;
  title?: string;
  disabled?: boolean;
  maxLength: number;
}

const FormBasicInfoInput = ({
  label,
  value,
  onChange,
  onBlur,
  inputProps,
  placeholder,
  disabled,
  maxLength,
  title,
  onClick,
}: FormBasicInfoInputProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const customTheme = createTheme({
    palette: {
      primary: {
        main: "#000000",
      },
    },
  });

  return (
    <div>
      <ThemeProvider theme={customTheme}>
        <TextField
          id="filled-basic"
          label={label}
          variant="filled"
          value={value}
          onChange={onChange}
          onClick={onClick}
          onBlur={() => {
            setIsFocused(false);
            if (onBlur) onBlur();
          }}
          onFocus={() => setIsFocused(true)}
          inputProps={{
            ...inputProps,
            maxLength,
          }}
          placeholder={placeholder}
          disabled={disabled}
          sx={{
            "& > :not(style)": { width: "33.2ch" },
            "& .MuiFilledInput-root": {
              borderRadius: "0px",
              backgroundColor: isFocused ? "#C1C7CC" : "#E0E2E5",
              fontSize: "17px",
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
            },
            "& .MuiInputLabel-root": {
              fontWeight: "500",
              fontSize: "20px",
            },
          }}
          focused
        />
      </ThemeProvider>
    </div>
  );
};

export default FormBasicInfoInput;
